module.exports = __webpack_public_path__ + "img/myguard_pro_01.2b354ea4.png";